import React, { useState, useEffect, useRef } from 'react'
import config from '../../config/config'
import { Row, Col } from 'react-bootstrap'

const GoogleMapEdit = ({ poi, onUpdateLocation }) => {
  const mapRef = useRef(null)
  const markerRef = useRef(null)
  const mapLoaded = useRef(false)
  const [gpsxInput, setGpsxInput] = useState(poi ? poi.gpsx : '')
  const [gpsyInput, setGpsyInput] = useState(poi ? poi.gpsy : '')

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
      script.async = true
      script.defer = true
      script.onload = loadMap
      document.head.appendChild(script)
    }

    const loadMap = () => {
      if (!window.google) {
        console.warn("Google Maps API n'est pas chargé.")
        return
      }

      const newLat = parseFloat(poi.gpsx)
      const newLng = parseFloat(poi.gpsy)
      if (
        !isNaN(newLat) &&
        !isNaN(newLng) &&
        isFinite(newLat) &&
        isFinite(newLng)
      ) {
        const map = new window.google.maps.Map(mapRef.current, {
          center: { lat: newLat, lng: newLng },
          zoom: config.mapPoiZoom,
          mapTypeId: 'terrain',
          styles: [
            {
              featureType: 'all',
              elementType: 'labels',
              stylers: [{ visibility: 'on' }],
            },
            {
              featureType: 'landscape.natural',
              elementType: 'geometry',
              stylers: [{ visibility: 'simplified' }, { color: '#7FBF7F' }],
            },
          ],
        })

        const markerIcon = `/images/markers/marker_50_PARAGLIDING.png`
        const marker = new window.google.maps.Marker({
          position: { lat: newLat, lng: newLng },
          map: map,
          title: poi.name,
          icon: markerIcon,
          draggable: true, // Activer le déplacement du marqueur
        })

        markerRef.current = marker

        // Gestion de l'événement de déplacement du marqueur
        window.google.maps.event.addListener(marker, 'dragend', () => {
          const newPosition = marker.getPosition()
          onUpdateLocation({
            gpsx: newPosition.lat(),
            gpsy: newPosition.lng(),
          })
          setGpsxInput(newPosition.lat())
          setGpsyInput(newPosition.lng())
        })

        mapLoaded.current = true
      } else {
        console.error('Invalid coordinates provided for map center.')
      }
    }

    if (poi && !mapLoaded.current) {
      if (!window.google) {
        loadGoogleMapsScript()
      } else {
        loadMap()
      }
    }
  }, [poi, onUpdateLocation])

  return (
    <div>
      <div ref={mapRef} style={{ height: '500px', width: '100%' }}></div>
      <Row>
        <Col>
          <label htmlFor="gpsx">Latitude:</label>
          <input
            type="text"
            id="gpsx"
            value={gpsxInput}
            onChange={(e) => setGpsxInput(e.target.value)}
            className="form-control"
          />
        </Col>
        <Col>
          <label htmlFor="gpsy">Longitude:</label>
          <input
            type="text"
            id="gpsy"
            value={gpsyInput}
            onChange={(e) => setGpsyInput(e.target.value)}
            className="form-control"
          />
        </Col>
      </Row>
    </div>
  )
}

export default GoogleMapEdit
